module.exports = __webpack_public_path__ + "img/roompad.e8da9dd8.jpg";